declare const __MAX_WORLDS__: number;

export const DEFAULT_WORLD_AUDIO_VOLUME = 0.75;

export function getMaxWorlds() {
    return __MAX_WORLDS__;
}

export const MAX_LEVEL_FACTOR: number = 5000;
export const MAX_HARVEST_AMOUNT: number = 5000;
